// extracted by mini-css-extract-plugin
export default {"root":"FloTextArea_root__dv+bP","invalid":"FloTextArea_invalid__FVWpJ"};